<template>
  <div id="card_info" class="uk-margin-auto">
    <h4 style="color:red; line-height: 0.4;">{{ $t('repay.h4_title') }}</h4>
    <p style="font-weight: 500; color:black;">{{ $t('repay.h4_subtitle') }}</p>
    <p style="font-weight: 500; color:black;">{{ $t('repay.h4_subtitle_1') }}</p>
    <p style="font-weight: 500; color:black; margin-top: -6px;">{{ $t('repay.h4_subtitle_2') }}
    </p>
    <div class="uk-flex uk-flex-right uk-margin-bottom">
      <a href="https://www.mbulak.kz/" target="_top"
         class="uk-button uk-button-small mbk_button_default">{{ $t('repay.to_main_site') }}</a>
    </div>
    <div class="uk-card uk-card-default uk-card-body uk-padding-remove-horizontal mbk_large_box_shadow">
      <stepper body-classes="repay_padding">
        <step :name="$t('repay.check')">
          <repay-form></repay-form>
        </step>
        <step :name="$t('repay.loans')">
          <repay-select-form></repay-select-form>
        </step>
        <step :name="$t('repay.payment')">
          <moneta-repay-form></moneta-repay-form>
        </step>
      </stepper>
    </div>
    <div v-if="is_ru_zone">

      <p style="font-size: 12px; text-align: center; margin-top: 15px;">
        После оплаты вы получите электронный кассовый чек от «М Булак» по смс на основной номер телефона.
        Обращаем внимание, что в соответствии с требованием закона кассовый чек оформляется только на сумму оплаченных процентов.
        Квитанция/чек/справка на всю сумму платежа формируется в прежнем порядке в зависимости от способа платежа.
      </p>

      <p style="font-size: 12px; text-align: center; margin-top: 15px;">М Булак предоставляет микрозаймы,
        которые можно оплатить с помощью банковской карты.
        Для перехода к оплате введите свои данные и нажмите кнопку «Проверить».</p>

      <p style="font-size: 12px; text-align: center; margin-top: -15px;">ООО "МКК М Булак" разъясняет, что не хранит
        данные ваших банковских карт. Компания соблюдает требования по информационной безопасности в соответствии с
        законодательством Российской Федерации. Безопасность платежей обеспечивается использованием TLS(SSL) протокола с
        256 - битным шифрованием для передачи конфиденциальной информации с платежной страницы на сервер процессингового
        центра банка-эквайера в соответствии с требованиями национальной платежной системы «МИР» и международных
        платежных систем Visa International и MasterCard International.</p>

      <p style="font-size: 12px; text-align: center; margin-top: -15px;">
        При успешном совершения платежа по займу, на ваш номер телефона придет СМС с подтверждением
        совершенной операции. Пример подтверждения: L/chet: 888.
        Vy uspeshno pogasili zaem. Summa pogasheniya: 888r.  Kvit: 12345678; 15.03.2023.
        Sled.pogashenie: 12.04.2023.Platite zaem udobno v prilojenii M Bulak.

        Пожалуйста сохраняйте данные подтверждения платежей до полного погашения займа.</p>

      <p style="font-size: 12px; text-align: center; margin-top: -18px;">Ознакомьтесь с <a
          href="https://www.molbulak.ru/docs/recomendacii-po-zhashite-informacii.pdf">Рекомендациями по защите
        информации ООО «МКК М Булак»</a>.</p>

      <p style="font-size: 12px; text-align: center; margin-top: -13px;">Если у вас возникнут вопросы при погашении вы
        можете позвонить нам по номеру: 8(800) 555 7171 или написать нам на почту ru.portal@mbulak.ru . ООО МКК "М
        Булак", 105120 г. Москва, пер. Наставнический, д.8, стр.2.</p>

    </div>
  </div>
</template>

<script>
import Stepper from "@/components/stepper/Stepper";
import Step from "@/components/stepper/Step";
import RepayForm from "@/components/RepayForm";
import RepaySelectForm from "@/components/RepaySelectForm";
import MonetaRepayForm from "@/components/MonetaRepayForm";

export default {
  name: "Repay",
  data() {
    return {
      is_ru_zone: false,
    }
  },
  components: {
    Stepper,
    Step,
    RepayForm,
    RepaySelectForm,
    MonetaRepayForm
  },
  created() {
    document.title = "Онлайн погашение займа";
    this.is_ru_zone = window.location.host.indexOf('.ru') > -1
  },
  computed: {
    spbLogoUrl() {
      // return process.env.NODE_ENV === "production" ? "/static/images/spb-logo.png" : "/images/spb-logo.png";
      return "/images/spb-logo.png";
    }
  }
};
</script>

<style>

#spb_logo {
  height: 50px;
}

#card_info {
  max-width: 900px;
}

.repay_padding {
  padding: 0 2rem;
}

@media only screen and (max-width: 520px) {
  .repay_padding {
    padding: 0 1rem;
  }
}

@media only screen and (max-width: 600px) {
  #spb_logo {
    height: 40px;
  }
}
</style>
